type FooterCopyrightProps = {
  testId?: string;
};

export function FooterCopyright({ testId }: FooterCopyrightProps) {
  const today = new Date();
  const year = today.getFullYear();
  return (
    <div
      data-testid={`${testId}-copyright`}
      className="font-opensans not-italic text-xs leading-4.5 text-grey-100"
    >
      <>
        MDDI (P) 002/04/2025. SPH Digital News Copyright © {year}. SPH Media
        Limited. Co. Regn. No. 202120748H. All Rights Reserved.
      </>
    </div>
  );
}
